import { gql } from "@apollo/client";

export enum EnumTrafficDriverStatus {
  APPROVED = "APPROVED",
  UNAPPROVED = "UNAPPROVED",
}

const trafficDriver = `
  _id
  headline
  ribbon
  imageId
  videoId
  teaser
  format
  destinationUrl
  status
  targeting {
    mode
    categoriesId
  }
  websites {
    _id
    name
  }
  websiteIds
`;

export const CREATE_TRAFFIC_DRIVER = gql`
  mutation($record: CreateTeaserInput!) {
    TeaserCreateOne(record: $record) {
      ${trafficDriver}
    }
  }
`;

export const UPDATE_TRAFFIC_DRIVER = gql`
  mutation ($id: ObjectId!, $record: UpdateTeaserInput!) {
    TeaserUpdateByID(_id: $id, record: $record) {
      ${trafficDriver}
    }
  }
`;

export const UPDATE_TRAFFIC_DRIVERS = gql`
  mutation TeaserUpdateByIds($records: [BulkUpdateTeaserInput!]!) {
    TeaserUpdateByIds(records: $records) {
      ${trafficDriver}
    }
  }
`;

export const DELETE_TRAFFIC_DRIVER = gql`
  mutation DeleteTeaser($id: ObjectId!) {
    TeaserDeleteByID(_id: $id)
  }
`;

export const GET_TRAFFIC_DRIVERS =gql`
query TeaserMany($filters: TeaserFilterArgs, $page: Int, $perPage: Int) {
  trafficDrivers: TeaserMany(filters: $filters, page: $page, perPage: $perPage) {
    items {
      _id
      headline
      imageId
      videoId
      video {
        _id
        status
        thumbnailUrl
        mediaUrl
      }
      teaser
      format
      destinationUrl
      status
      ribbon
      targeting {
        mode
        categoriesId
      }
      websiteIds
      websites {
        _id
        name
        publisherId
      }
      previewLinks {
        websiteId
        websiteName
        url
      }
    }
    meta {
      totalItems
    }
  }
}
`
export const GET_REPORTING_TRAFFIC_DRIVERS =gql`
query TeaserMany($filters: TrafficDriverFilterArgs, $page: Int, $perPage: Int) {
  TeaserMany(filters: $filters, page: $page, perPage: $perPage) {
    items {
      _id
      headline
    }
  }
}
`

export const GET_CONTENT_CATEGORIES = gql`
  query {
    contentCategories: IABContentCategoryRoot {
      value: _id
      label: name
    }
  }
`
